export default __webpack_public_path__ + "static/media/gangsterSeal.028cc060.png";